import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[hoverDirective]',
})

export class HoverDirective {
    @Output() hover: EventEmitter<boolean> = new EventEmitter();

    constructor(private el: ElementRef) {}

    @HostListener('mouseenter')
    onMouseEnter() {
        this.hover.emit(true);
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.hover.emit(false);
    }
}
